import { defineMessages } from 'react-intl';

export default defineMessages({
  charityVettingContactDialogLabel: {
    id: 'charity.vetting.contact.dialog.label',
    defaultMessage: 'Need help?',
  },
  charityVettingContactDialogText: {
    id: 'charity.vetting.contact.dialog.text',
    defaultMessage:
      'If you need assistance or have any questions, please don’t hesitate to contact us at:',
  },
});
